import { useCustomEvents } from "mkm-gtm";

export type Area = {
  len: number;
  width: number;
};

const getAttributeValue = (list: any[], attr: string) =>
  list?.find((obj) => obj.name === attr)?.values?.[0] || list?.find((obj) => obj.name === attr)?.value || null;

const useQtyTray = ({ product, withWastage, startTime, endTime, isCalculated }: any) => {
  const { pushCustomEvent, CustomEvents } = useCustomEvents();
  const { selectedBranch } = useBranches();
  const { user } = useUser();

  const productType = getAttributeValue(product.custom_fields, "product_type") || "";

  const fireOpenTray = () => {
    deferExecution(() =>
      pushCustomEvent(CustomEvents.QTY_CALC_OPEN, {
        product_id: product.id,
        product_name: product.name,
        product_category: productType,
        branch_id: selectedBranch.value?.id,
        user_type: user.value?.account.business_type.split("|"),
        device_type: detectWindow("device"),
        pdp_url: product.custom_url.url,
      } as any),
    );
  };

  const fireCloseTray = (closingMethod: string) => {
    deferExecution(() =>
      pushCustomEvent(CustomEvents.QTY_CALC_CLOSED, {
        closed_method: closingMethod,
        time_spent_open: (endTime.value - startTime.value) / 1000,
        form_completed: isCalculated.value,
        product_id: product.id,
        product_category: productType,
      } as any),
    );
  };

  const fireCalculationEvent = ({ numOfUnits, unit_price, total, ...rest }: any) => {
    deferExecution(() =>
      pushCustomEvent(CustomEvents.QTY_CALCULATED, {
        product_id: product.id,
        calculated_quantity: numOfUnits,
        unit_price_ex_vat: unit_price,
        unit_price_inc_vat: unit_price * 1.2,
        total_value_estimate_ex_vat: total,
        total_value_estimate_inc_vat: total * 1.2,
        buffer_added: withWastage.value,
        product_category: productType,
        user_type: user.value?.account.business_type.split("|"),
        branch_id: selectedBranch.value?.id,
        ...rest,
      } as any),
    );
  };

  return {
    fireOpenTray,
    fireCloseTray,
    fireCalculationEvent,
  };
};

export default useQtyTray;
